export function formatFullAddress(address: HasCityAndAddress) {
    return `${address.city}, ${address.address}`;
}


export interface HasCityAndAddress {
    city: string;
    address: string;
}
